module.exports = __webpack_public_path__ + "img/lime_oak_976m_list.8044ccf2.jpg";